/* Manuel Bozzi — global theme JavaScript.
   Vanilla custom elements; resilient to Theme Editor section reloads. */

(function () {
  "use strict";

  var routes = window.themeRoutes || {
    cart_add_url: "/cart/add",
    cart_change_url: "/cart/change",
    cart_url: "/cart",
    root_url: "/",
  };

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || "€{{amount_with_comma_separator}}";
    var value = (cents / 100).toFixed(2);
    var parts = value.split(".");
    var euros = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var withComma = euros + "," + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
    var formatted = format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, euros)
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
    var decoder = document.createElement("span");
    decoder.innerHTML = formatted;
    return decoder.textContent;
  }

  /* ---------- Analytics ---------- */

  var Analytics = {
    capture: function (eventName, properties) {
      if (window.posthog && typeof window.posthog.capture === "function") {
        window.posthog.capture(eventName, properties || {});
      }
    },
    dataLayer: function (eventName, properties) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, properties || {}));
    },
    ecommerce: function (posthogEvent, posthogProperties, gtmEvent, ecommerce) {
      this.capture(posthogEvent, posthogProperties);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: gtmEvent, ecommerce: ecommerce });
    },
  };

  function analyticsCurrency() {
    return window.themeCurrency || "EUR";
  }

  function absoluteUrl(url) {
    try {
      return new URL(url, window.location.origin).toString();
    } catch (e) {
      return url || window.location.href;
    }
  }

  function ga4Item(product) {
    return {
      item_id: product.sku || product.variant_id || product.product_id,
      item_name: product.name,
      item_brand: product.brand,
      item_category: product.category,
      item_variant: product.variant,
      price: product.price,
      quantity: product.quantity || 1,
      index: product.position,
    };
  }

  function productProperties(product, variant, quantity) {
    var priceCents = variant.final_price != null ? variant.final_price : variant.price;
    var price = Number(priceCents || 0) / 100;
    return {
      product_id: String(product.product_id || product.id || ""),
      variant_id: String(variant.variant_id || variant.id || ""),
      sku: variant.sku || "",
      category: product.type || product.product_type || "",
      name: product.product_title || product.title || variant.product_title || variant.title || "",
      brand: product.vendor || variant.vendor || "",
      variant: variant.variant_title || variant.title || "",
      price: price,
      quantity: quantity || variant.quantity || 1,
      currency: analyticsCurrency(),
      value: price * (quantity || variant.quantity || 1),
      url: absoluteUrl(product.url || variant.url || window.location.pathname),
    };
  }

  function productFromCard(card, position) {
    var price = Number(card.getAttribute("data-product-price-cents") || 0) / 100;
    return {
      product_id: card.getAttribute("data-product-id") || "",
      variant_id: card.getAttribute("data-variant-id") || "",
      sku: card.getAttribute("data-product-sku") || "",
      category: card.getAttribute("data-product-category") || "",
      name: card.getAttribute("data-product-name") || "",
      brand: card.getAttribute("data-product-brand") || "",
      variant: card.getAttribute("data-variant-name") || "",
      price: price,
      quantity: 1,
      currency: analyticsCurrency(),
      value: price,
      position: position,
      url: absoluteUrl(card.getAttribute("href")),
    };
  }

  function cartProperties(container) {
    if (!container) return null;
    var products = [];
    container.querySelectorAll("[data-cart-item]").forEach(function (item) {
      var quantity = Number(item.getAttribute("data-item-quantity") || 1);
      var price = Number(item.getAttribute("data-item-price-cents") || 0) / 100;
      products.push({
        product_id: item.getAttribute("data-product-id") || "",
        variant_id: item.getAttribute("data-variant-id") || "",
        sku: item.getAttribute("data-product-sku") || "",
        category: item.getAttribute("data-product-category") || "",
        name: item.getAttribute("data-product-name") || "",
        brand: item.getAttribute("data-product-brand") || "",
        variant: item.getAttribute("data-variant-name") || "",
        price: price,
        quantity: quantity,
        currency: analyticsCurrency(),
        value: price * quantity,
        url: absoluteUrl(item.getAttribute("data-product-url")),
      });
    });
    return {
      cart_id: container.getAttribute("data-cart-id") || "",
      currency: analyticsCurrency(),
      value: Number(container.getAttribute("data-cart-total-cents") || 0) / 100,
      products: products,
    };
  }

  function trackCart(eventName, gtmEvent, container) {
    var cart = cartProperties(container);
    if (!cart || !cart.products.length) return;
    Analytics.ecommerce(eventName, cart, gtmEvent, {
      currency: cart.currency,
      value: cart.value,
      items: cart.products.map(ga4Item),
    });
  }

  function trackCartView(container) {
    trackCart("Cart Viewed", "view_cart", container);
  }

  function initProductLists(scope) {
    (scope || document).querySelectorAll("[data-product-list]").forEach(function (list) {
      if (list.mbAnalyticsViewed || list.closest("[hidden]")) return;
      var cards = Array.from(list.querySelectorAll("[data-product-card]"));
      if (!cards.length) return;
      list.mbAnalyticsViewed = true;
      var listId = list.getAttribute("data-product-list-id") || window.location.pathname;
      var listName = list.getAttribute("data-product-list") || document.title;
      var products = cards.map(function (card, index) {
        return productFromCard(card, index + 1);
      });
      Analytics.ecommerce(
        "Product List Viewed",
        { list_id: listId, list_name: listName, products: products },
        "view_item_list",
        {
          item_list_id: listId,
          item_list_name: listName,
          items: products.map(ga4Item),
        },
      );
    });
  }

  function initPageAnalytics(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-analytics-success]").forEach(function (status) {
      if (status.mbAnalyticsCaptured) return;
      status.mbAnalyticsCaptured = true;
      Analytics.capture(status.getAttribute("data-analytics-success"), {
        form_name: status.getAttribute("data-analytics-form") || "",
      });
      var gtmEvent = status.getAttribute("data-analytics-gtm-event");
      if (gtmEvent) {
        Analytics.dataLayer(gtmEvent, { form_name: status.getAttribute("data-analytics-form") || "" });
      }
    });

    root.querySelectorAll("[data-search-analytics]").forEach(function (search) {
      if (search.mbAnalyticsCaptured) return;
      search.mbAnalyticsCaptured = true;
      var query = search.getAttribute("data-search-query") || "";
      var resultsCount = Number(search.getAttribute("data-search-results") || 0);
      Analytics.capture("Products Searched", { query: query, results_count: resultsCount });
      Analytics.dataLayer("search", { search_term: query, results_count: resultsCount });
    });

    root.querySelectorAll("[data-cart-page]").forEach(function (cartPage) {
      if (cartPage.mbAnalyticsViewed) return;
      cartPage.mbAnalyticsViewed = true;
      trackCartView(cartPage);
    });
  }

  /* ---------- Cart drawer ---------- */

  var CartDrawer = {
    el: function () {
      return document.getElementById("mb-cart-drawer");
    },
    overlay: function () {
      return document.getElementById("mb-cart-overlay");
    },
    open: function () {
      var el = this.el();
      var ov = this.overlay();
      if (!el) return;
      var wasOpen = el.classList.contains("is-open");
      el.classList.add("is-open");
      if (ov) ov.classList.add("is-open");
      document.documentElement.classList.add("mb-lock");
      var closeBtn = el.querySelector("[data-drawer-close]");
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      if (!wasOpen) trackCartView(el);
    },
    close: function () {
      var el = this.el();
      var ov = this.overlay();
      if (el) el.classList.remove("is-open");
      if (ov) ov.classList.remove("is-open");
      document.documentElement.classList.remove("mb-lock");
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(routes.root_url + "?sections=cart-drawer")
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          var html = sections["cart-drawer"];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("mb-cart-drawer");
          var current = self.el();
          if (fresh && current) {
            var wasOpen = current.classList.contains("is-open");
            current.innerHTML = fresh.innerHTML;
            var count = fresh.getAttribute("data-cart-count");
            current.setAttribute("data-cart-count", count || "0");
            ["data-cart-id", "data-cart-total-cents"].forEach(function (attribute) {
              current.setAttribute(attribute, fresh.getAttribute(attribute) || "");
            });
            syncCartCount(count || "0");
            if (wasOpen || openAfter) self.open();
          }
        });
    },
  };

  function syncCartCount(count) {
    document.querySelectorAll("[data-cart-count-display]").forEach(function (el) {
      el.textContent = count;
    });
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-cart-open]");
    if (opener) {
      event.preventDefault();
      CartDrawer.open();
      return;
    }
    var closer = event.target.closest("[data-drawer-close], #mb-cart-overlay");
    if (closer) {
      event.preventDefault();
      CartDrawer.close();
    }
  });

  document.addEventListener("click", function (event) {
    var card = event.target.closest("[data-product-card]");
    if (card) {
      var list = card.closest("[data-product-list]");
      var cards = list ? Array.from(list.querySelectorAll("[data-product-card]")) : [card];
      var product = productFromCard(card, cards.indexOf(card) + 1);
      Analytics.ecommerce("Product Clicked", product, "select_item", {
        item_list_id: list ? list.getAttribute("data-product-list-id") || window.location.pathname : "",
        item_list_name: list ? list.getAttribute("data-product-list") || document.title : document.title,
        items: [ga4Item(product)],
      });
    }

    var checkout = event.target.closest('[name="checkout"]');
    if (checkout) {
      trackCart("Checkout Started", "begin_checkout", checkout.closest("[data-cart-analytics]"));
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") CartDrawer.close();
  });

  var socialVideoDrag = null;
  var suppressSocialVideoClick = false;

  document.addEventListener(
    "pointerdown",
    function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      var rail = event.target.closest("[data-social-video-rail]");
      if (!rail) return;
      socialVideoDrag = {
        rail: rail,
        pointerId: event.pointerId,
        startX: event.clientX,
        startScrollLeft: rail.scrollLeft,
        moved: false,
      };
    },
    true,
  );

  document.addEventListener(
    "pointermove",
    function (event) {
      var drag = socialVideoDrag;
      if (!drag || event.pointerId !== drag.pointerId || event.buttons !== 1) return;
      var distance = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(distance) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.rail.classList.add("is-dragging");
      }
      drag.rail.scrollLeft = drag.startScrollLeft - distance;
      event.preventDefault();
    },
    true,
  );

  function endSocialVideoDrag(event) {
    if (!socialVideoDrag || (event && event.pointerId !== socialVideoDrag.pointerId)) return;
    if (socialVideoDrag.moved) {
      suppressSocialVideoClick = true;
      window.setTimeout(function () {
        suppressSocialVideoClick = false;
      }, 0);
    }
    socialVideoDrag.rail.classList.remove("is-dragging");
    socialVideoDrag = null;
  }

  document.addEventListener("pointerup", endSocialVideoDrag, true);
  document.addEventListener("pointercancel", endSocialVideoDrag, true);
  window.addEventListener("blur", function () {
    endSocialVideoDrag();
  });

  document.addEventListener(
    "click",
    function (event) {
      if (!suppressSocialVideoClick || !event.target.closest("[data-social-video-rail]")) return;
      event.preventDefault();
      event.stopPropagation();
      suppressSocialVideoClick = false;
    },
    true,
  );

  document.addEventListener(
    "play",
    function (event) {
      if (!event.target.matches(".mb-social-videos video")) return;
      document.querySelectorAll(".mb-social-videos video").forEach(function (video) {
        if (video !== event.target) video.pause();
      });
    },
    true,
  );

  /* ---------- Search dialog ---------- */

  var SearchDialog = {
    lastFocus: null,
    focusTimer: null,
    el: function () {
      return document.getElementById("mb-search-dialog");
    },
    overlay: function () {
      return document.querySelector(".mb-search-overlay");
    },
    open: function (opener) {
      var el = this.el();
      if (!el) return;
      this.lastFocus =
        opener && opener.closest("#mb-mobile-menu")
          ? document.querySelector("[data-mobile-menu-open]")
          : opener || document.activeElement;
      CartDrawer.close();
      if (typeof MobileMenu !== "undefined") MobileMenu.close();
      el.classList.add("is-open");
      el.setAttribute("aria-hidden", "false");
      var overlay = this.overlay();
      if (overlay) overlay.classList.add("is-open");
      document.querySelectorAll("[data-search-open]").forEach(function (button) {
        button.setAttribute("aria-expanded", "true");
      });
      document.documentElement.classList.add("mb-lock");
      var input = el.querySelector('input[type="search"]');
      if (input) {
        window.clearTimeout(this.focusTimer);
        this.focusTimer = window.setTimeout(function () {
          input.focus();
        }, 80);
      }
    },
    close: function () {
      var el = this.el();
      if (!el || !el.classList.contains("is-open")) return;
      window.clearTimeout(this.focusTimer);
      this.focusTimer = null;
      el.classList.remove("is-open");
      el.setAttribute("aria-hidden", "true");
      var overlay = this.overlay();
      if (overlay) overlay.classList.remove("is-open");
      document.querySelectorAll("[data-search-open]").forEach(function (button) {
        button.setAttribute("aria-expanded", "false");
      });
      document.documentElement.classList.remove("mb-lock");
      if (this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus();
    },
  };

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-search-open]");
    if (opener) {
      event.preventDefault();
      SearchDialog.open(opener);
      return;
    }
    if (event.target.closest("[data-search-close]")) {
      event.preventDefault();
      SearchDialog.close();
    }
  });

  document.addEventListener("keydown", function (event) {
    var dialog = SearchDialog.el();
    if (!dialog || !dialog.classList.contains("is-open")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      SearchDialog.close();
      return;
    }
    if (event.key !== "Tab") return;
    var focusable = Array.prototype.slice.call(
      dialog.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
      ),
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------- Quantity + line item updates ---------- */

  var MbQty = (function () {
    function change(line, quantity) {
      return fetch(routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function () {
        if (document.getElementById("mb-cart-page")) {
          window.location.reload();
        } else {
          CartDrawer.refresh(false);
        }
      });
    }
    return { change: change };
  })();

  document.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-qty-change]");
    if (btn) {
      event.preventDefault();
      var line = parseInt(btn.getAttribute("data-line"), 10);
      var qty = parseInt(btn.getAttribute("data-qty-change"), 10);
      if (!isNaN(line) && !isNaN(qty)) MbQty.change(line, Math.max(qty, 0));
      return;
    }
    var remove = event.target.closest("[data-line-remove]");
    if (remove) {
      event.preventDefault();
      var l = parseInt(remove.getAttribute("data-line"), 10);
      if (!isNaN(l)) MbQty.change(l, 0);
    }
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-qty-input]");
    if (input) {
      var line = parseInt(input.getAttribute("data-line"), 10);
      var qty = parseInt(input.value, 10);
      if (!isNaN(line) && !isNaN(qty)) MbQty.change(line, Math.max(qty, 0));
    }
  });

  /* ---------- Header visibility while scrolling ---------- */

  var headerScrollCleanup = null;

  function initHeaderScroll(scope) {
    var header = (scope || document).querySelector(".mb-header");
    if (!header) return;
    var root = header.closest(".mb-header-section");
    if (!root || root.mbScrollBound) return;
    if (headerScrollCleanup) headerScrollCleanup();
    root.mbScrollBound = true;

    var abort = new AbortController();
    var frame = null;
    var lastY = Math.max(0, window.scrollY);

    function show() {
      root.classList.remove("is-scroll-hidden");
      lastY = Math.max(0, window.scrollY);
    }

    function update() {
      frame = null;
      var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = Math.max(0, Math.min(window.scrollY, maxY));
      if (
        y <= header.offsetHeight ||
        root.contains(document.activeElement) ||
        root.querySelector(".is-open") ||
        document.documentElement.classList.contains("mb-lock") ||
        window.Shopify?.designMode
      ) {
        show();
        return;
      }
      var delta = y - lastY;
      if (Math.abs(delta) < 4) return;
      root.classList.toggle("is-scroll-hidden", delta > 0);
      lastY = y;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!frame) frame = requestAnimationFrame(update);
      },
      { passive: true, signal: abort.signal },
    );
    root.addEventListener("focusin", show, { signal: abort.signal });
    document.addEventListener(
      "keydown",
      function (event) {
        if (event.key === "Tab") show();
      },
      { signal: abort.signal },
    );
    document.addEventListener(
      "shopify:section:unload",
      function (event) {
        if (event.target === root) headerScrollCleanup();
      },
      { signal: abort.signal },
    );
    headerScrollCleanup = function () {
      abort.abort();
      cancelAnimationFrame(frame);
      root.mbScrollBound = false;
      root.classList.remove("is-scroll-hidden");
      headerScrollCleanup = null;
    };
  }

  /* ---------- Header dropdown menus ---------- */

  function initHeaderMenus(scope) {
    (scope || document).querySelectorAll("[data-menu-parent]").forEach(function (parent) {
      if (parent.mbBound) return;
      parent.mbBound = true;
      var panel = parent.querySelector("[data-menu-panel]");
      if (!panel) return;
      var hide = null;
      var trigger = parent.querySelector("[data-menu-trigger]");
      function setOpen(open) {
        panel.classList.toggle("is-open", open);
        if (trigger) trigger.setAttribute("aria-expanded", String(open));
      }
      parent.addEventListener("mouseenter", function () {
        clearTimeout(hide);
        setOpen(true);
      });
      parent.addEventListener("mouseleave", function () {
        hide = setTimeout(function () {
          setOpen(false);
        }, 120);
      });
      if (trigger) {
        if (trigger.tagName !== "BUTTON") {
          trigger.addEventListener("focus", function () {
            setOpen(true);
          });
        }
        parent.addEventListener("focusout", function (e) {
          if (!parent.contains(e.relatedTarget)) setOpen(false);
        });
        if (trigger.tagName === "BUTTON") {
          trigger.addEventListener("click", function () {
            setOpen(true);
          });
          trigger.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
              setOpen(false);
              trigger.focus();
            }
          });
        }
      }
    });
  }

  /* ---------- Mobile menu drawer ---------- */

  var MobileMenu = {
    el: function () {
      return document.getElementById("mb-mobile-menu");
    },
    overlay: function () {
      return document.getElementById("mb-menu-overlay");
    },
    opener: function () {
      return document.querySelector("[data-mobile-menu-open]");
    },
    open: function () {
      var menu = this.el();
      var overlay = this.overlay();
      var opener = this.opener();
      if (!menu) return;
      menu.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      if (opener) opener.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("mb-lock");
      var closeBtn = menu.querySelector("[data-mobile-menu-close]");
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    },
    close: function () {
      var menu = this.el();
      var overlay = this.overlay();
      var opener = this.opener();
      if (menu) menu.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      if (opener) opener.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("mb-lock");
    },
  };

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-mobile-menu-open]");
    if (opener) {
      event.preventDefault();
      MobileMenu.open();
      return;
    }
    var closer = event.target.closest("[data-mobile-menu-close], #mb-menu-overlay");
    if (closer) {
      event.preventDefault();
      MobileMenu.close();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") MobileMenu.close();
  });

  /* ---------- Size guide modal ---------- */

  function initSizeGuides(scope) {
    (scope || document).querySelectorAll("[data-size-guide-modal]").forEach(function (modal) {
      if (modal.mbBound) return;
      modal.mbBound = true;

      modal.addEventListener("close", function () {
        document.documentElement.classList.remove("mb-lock");
        if (modal.mbOpener && document.contains(modal.mbOpener)) {
          modal.mbOpener.focus({ preventScroll: true });
        }
      });

      modal.addEventListener("click", function (event) {
        if (event.target === modal) modal.close();
      });
    });
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-size-guide-open]");
    if (opener) {
      var modal = document.getElementById(opener.getAttribute("aria-controls"));
      if (!modal || typeof modal.showModal !== "function") return;
      event.preventDefault();
      modal.mbOpener = opener;
      modal.showModal();
      document.documentElement.classList.add("mb-lock");
      var closeButton = modal.querySelector("[data-size-guide-close]");
      if (closeButton) closeButton.focus({ preventScroll: true });
      return;
    }

    var closeButton = event.target.closest("[data-size-guide-close]");
    if (closeButton) {
      event.preventDefault();
      var openModal = closeButton.closest("[data-size-guide-modal]");
      if (openModal) openModal.close();
      return;
    }

    var tab = event.target.closest("[data-size-guide-tab]");
    if (tab) {
      event.preventDefault();
      var tabModal = tab.closest("[data-size-guide-modal]");
      var target = tab.getAttribute("data-size-guide-tab");
      tabModal.querySelectorAll("[data-size-guide-tab]").forEach(function (item) {
        var active = item === tab;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
        item.tabIndex = active ? 0 : -1;
      });
      tabModal.querySelectorAll("[data-size-guide-panel]").forEach(function (panel) {
        panel.hidden = panel.getAttribute("data-size-guide-panel") !== target;
      });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    var modal = document.querySelector("[data-size-guide-modal][open]");
    if (!modal) return;
    event.preventDefault();
    modal.close();
  });

  /* ---------- Accordion deep links (e.g. /pages/size-guide-it#bracciale) ---------- */

  function openAccordionFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var id;
    try {
      id = decodeURIComponent(location.hash.slice(1));
    } catch (error) {
      return;
    }
    var target = document.getElementById(id);
    if (target && target.tagName === "DETAILS" && !target.open) target.open = true;
  }

  window.addEventListener("hashchange", openAccordionFromHash);

  /* ---------- Custom dropdown (product options, sorting) ---------- */

  function closeAllDropdowns(except) {
    document.querySelectorAll("[data-dropdown].is-open").forEach(function (dd) {
      if (dd !== except) dd.classList.remove("is-open");
    });
  }

  document.addEventListener("click", function (event) {
    var toggle = event.target.closest("[data-dropdown-toggle]");
    if (toggle) {
      event.preventDefault();
      var dd = toggle.closest("[data-dropdown]");
      var willOpen = !dd.classList.contains("is-open");
      closeAllDropdowns(dd);
      dd.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      return;
    }
    var option = event.target.closest("[data-dropdown-option]");
    if (option) {
      event.preventDefault();
      var dropdown = option.closest("[data-dropdown]");
      if (option.hasAttribute("data-disabled")) return;
      var value = option.getAttribute("data-value");
      var label = dropdown.querySelector("[data-dropdown-label]");
      if (label) label.textContent = option.getAttribute("data-label") || value;
      dropdown.setAttribute("data-selected", value);
      dropdown.classList.remove("is-open");
      dropdown.querySelectorAll("[data-dropdown-option]").forEach(function (o) {
        o.classList.toggle("is-selected", o === option);
      });
      dropdown.dispatchEvent(new CustomEvent("mb:dropdown:change", { bubbles: true, detail: { value: value } }));
      return;
    }
    if (!event.target.closest("[data-dropdown]")) closeAllDropdowns(null);
  });

  /* ---------- Product form ---------- */

  function initRecipientForms(scope) {
    (scope || document).querySelectorAll("[data-recipient-form]").forEach(function (recipientForm) {
      if (recipientForm.mbBound) return;
      recipientForm.mbBound = true;

      var toggle = recipientForm.querySelector("[data-recipient-toggle]");
      var fields = recipientForm.querySelector("[data-recipient-fields]");
      var inputs = recipientForm.querySelectorAll("[data-recipient-input]");
      var email = recipientForm.querySelector("[data-recipient-email]");
      var offset = recipientForm.querySelector("[data-recipient-offset]");
      var message = recipientForm.querySelector("[data-recipient-message]");
      var count = recipientForm.querySelector("[data-recipient-count]");
      if (!toggle || !fields) return;

      function updateCount() {
        if (message && count) count.textContent = String(message.value.length);
      }

      function updateRecipientFields() {
        var enabled = toggle.checked;
        fields.hidden = !enabled;
        toggle.setAttribute("aria-expanded", enabled ? "true" : "false");
        inputs.forEach(function (input) {
          input.disabled = !enabled;
        });
        if (email) email.required = enabled;
        if (offset) offset.value = String(new Date().getTimezoneOffset());
        updateCount();
      }

      toggle.addEventListener("change", updateRecipientFields);
      if (message) message.addEventListener("input", updateCount);
      updateRecipientFields();
    });
  }

  function initProductForms(scope) {
    (scope || document).querySelectorAll("[data-product-form-wrap]").forEach(function (wrap) {
      if (wrap.mbBound) return;
      wrap.mbBound = true;

      var dataEl = wrap.querySelector("[data-product-json]");
      if (!dataEl) return;
      var product;
      var variantMedia = {};
      try {
        product = JSON.parse(dataEl.textContent);
        var variantMediaEl = wrap.querySelector("[data-variant-media-json]");
        if (variantMediaEl) variantMedia = JSON.parse(variantMediaEl.textContent);
      } catch (e) {
        return;
      }

      var gallery = wrap.querySelector("[data-gallery]");
      var form = wrap.querySelector("form[data-product-form]");
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = wrap.querySelector("[data-product-price]");
      var codeEl = wrap.querySelector("[data-product-code]");
      var buyBtn = wrap.querySelector("[data-add-to-cart]");
      var buyBtnText = wrap.querySelector("[data-add-to-cart-text]");
      var productViewTracked = false;

      function selectedOptions() {
        var opts = [];
        wrap.querySelectorAll("[data-dropdown][data-option-index]").forEach(function (dd) {
          opts[parseInt(dd.getAttribute("data-option-index"), 10)] = dd.getAttribute("data-selected");
        });
        return opts;
      }

      function findVariant(opts) {
        if (!opts.length) {
          // Products with a single "Default Title" variant render no option selectors:
          // resolve to the variant already in the form, falling back to the first one.
          var currentId = idInput ? parseInt(idInput.value, 10) : NaN;
          return (
            product.variants.find(function (v) {
              return v.id === currentId;
            }) || product.variants[0]
          );
        }
        return product.variants.find(function (v) {
          return v.options.every(function (value, i) {
            return value === opts[i];
          });
        });
      }

      function updateAvailabilityNotes() {
        var opts = selectedOptions();
        wrap.querySelectorAll("[data-dropdown][data-option-index]").forEach(function (dd) {
          var index = parseInt(dd.getAttribute("data-option-index"), 10);
          dd.querySelectorAll("[data-dropdown-option]").forEach(function (optionEl) {
            var candidate = opts.slice();
            candidate[index] = optionEl.getAttribute("data-value");
            var variant = findVariant(candidate);
            var unavailable = !variant || !variant.available;
            optionEl.classList.toggle("is-unavailable", unavailable);
            var note = optionEl.querySelector("[data-option-note]");
            if (note) note.hidden = !unavailable;
          });
        });
      }

      function refresh() {
        var variant = findVariant(selectedOptions());
        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (codeEl) {
            codeEl.hidden = !variant.sku;
            codeEl.textContent = variant.sku
              ? (codeEl.getAttribute("data-code-label") || "Codice") + " " + variant.sku.toUpperCase()
              : "";
          }
          if (buyBtn) buyBtn.disabled = !variant.available;
          if (buyBtnText) {
            buyBtnText.textContent = variant.available
              ? (buyBtn.getAttribute("data-label-add") || "").replace("[price]", formatMoney(variant.price))
              : buyBtn.getAttribute("data-label-soldout") || "";
          }
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
          if (gallery) {
            gallery.dispatchEvent(
              new CustomEvent("mb:gallery:show-media", { detail: { mediaId: variantMedia[String(variant.id)] } }),
            );
          }
          if (!productViewTracked) {
            productViewTracked = true;
            var viewedProduct = productProperties(product, variant, 1);
            Analytics.ecommerce("Product Viewed", viewedProduct, "view_item", {
              currency: viewedProduct.currency,
              value: viewedProduct.value,
              items: [ga4Item(viewedProduct)],
            });
          }
        } else if (buyBtn) {
          buyBtn.disabled = true;
          if (buyBtnText) buyBtnText.textContent = buyBtn.getAttribute("data-label-unavailable") || "";
        }
        updateAvailabilityNotes();
      }

      wrap.addEventListener("mb:dropdown:change", refresh);
      refresh();

      if (form) {
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          if (buyBtn) buyBtn.classList.add("is-loading");
          var payload = {
            id: parseInt(idInput.value, 10),
            quantity: 1,
          };
          var properties = {};
          new FormData(form).forEach(function (value, key) {
            var match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== "") properties[match[1]] = value;
          });
          if (Object.keys(properties).length) payload.properties = properties;
          fetch(routes.cart_add_url + ".js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: JSON.stringify(payload),
          })
            .then(function (r) {
              if (!r.ok) throw new Error("add failed");
              return r.json();
            })
            .then(function (item) {
              var addedProduct = productProperties(item, item, item.quantity || 1);
              Analytics.ecommerce("Product Added", addedProduct, "add_to_cart", {
                currency: addedProduct.currency,
                value: addedProduct.value,
                items: [ga4Item(addedProduct)],
              });
              return CartDrawer.refresh(true);
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              if (buyBtn) buyBtn.classList.remove("is-loading");
            });
        });
      }
    });
  }

  /* ---------- Product gallery ---------- */

  function initGalleries(scope) {
    (scope || document).querySelectorAll("[data-gallery]").forEach(function (gallery) {
      if (gallery.mbBound) return;
      gallery.mbBound = true;
      var slides = gallery.querySelectorAll("[data-gallery-slide]");
      var counter = gallery.querySelector("[data-gallery-current]");
      var current = Array.prototype.findIndex.call(slides, function (slide) {
        return slide.classList.contains("is-active");
      });
      if (current < 0) current = 0;
      function showSlide(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === current);
          slide.setAttribute("aria-hidden", i === current ? "false" : "true");
          if (i !== current) {
            slide.querySelectorAll("video").forEach(function (video) {
              video.pause();
            });
          }
        });
        if (counter) counter.textContent = String(current + 1);
      }
      gallery.addEventListener("mb:gallery:show-media", function (event) {
        var mediaId = event.detail && event.detail.mediaId;
        var index = Array.prototype.findIndex.call(slides, function (slide) {
          return slide.getAttribute("data-media-id") === String(mediaId);
        });
        showSlide(index < 0 ? 0 : index);
      });
      gallery.querySelectorAll("[data-gallery-step]").forEach(function (button) {
        button.addEventListener("click", function () {
          showSlide(current + Number(button.getAttribute("data-gallery-step")));
        });
      });
      var touchStart = null;
      gallery.addEventListener(
        "touchstart",
        function (event) {
          if (event.touches.length !== 1 || !event.target.closest(".mb-product__slide img")) return;
          touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        },
        { passive: true },
      );
      gallery.addEventListener("touchend", function (event) {
        if (!touchStart) return;
        var dx = event.changedTouches[0].clientX - touchStart.x;
        var dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showSlide(current + (dx < 0 ? 1 : -1));
      });
      gallery.addEventListener("touchcancel", function () {
        touchStart = null;
      });
      showSlide(current);
    });
  }

  /* ---------- Tabs (featured collections) ---------- */

  function initTabs(scope) {
    (scope || document).querySelectorAll("[data-tabs]").forEach(function (tabs) {
      if (tabs.mbBound) return;
      tabs.mbBound = true;
      tabs.querySelectorAll("[data-tab-trigger]").forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var target = trigger.getAttribute("data-tab-trigger");
          tabs.querySelectorAll("[data-tab-trigger]").forEach(function (t) {
            t.classList.toggle("is-active", t === trigger);
          });
          tabs.querySelectorAll("[data-tab-panel]").forEach(function (panel) {
            panel.hidden = panel.getAttribute("data-tab-panel") !== target;
          });
          initProductLists(tabs);
        });
      });
    });
  }

  /* ---------- Trustpilot ---------- */

  function initTrustpilot(scope) {
    (scope || document).querySelectorAll("[data-mb-trustpilot-count]").forEach(function (element) {
      var businessUnitId = element.dataset.businessunitId;
      if (!businessUnitId || element.mbTrustpilotRequested) return;
      element.mbTrustpilotRequested = true;
      fetch(
        "https://widget.trustpilot.com/trustbox-data/5419b6a8b0d04a076446a9ad?businessUnitId=" +
          encodeURIComponent(businessUnitId) +
          "&locale=" +
          encodeURIComponent(document.documentElement.lang || "it-IT"),
      )
        .then(function (response) {
          if (!response.ok) throw new Error("Trustpilot unavailable");
          return response.json();
        })
        .then(function (data) {
          var total = data.businessUnit && data.businessUnit.numberOfReviews && data.businessUnit.numberOfReviews.total;
          if (!Number.isSafeInteger(total) || total < 0) return;
          element.textContent = new Intl.NumberFormat(document.documentElement.lang || "it-IT").format(total);
          element.hidden = false;
        })
        .catch(function () {
          element.mbTrustpilotRequested = false;
        });
    });

    var widgets = Array.from((scope || document).querySelectorAll("[data-mb-trustpilot-widget]")).filter(
      function (widget) {
        return !widget.mbTrustpilotLoaded;
      },
    );
    if (!widgets.length) return;

    function loadWidgets() {
      if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== "function") return;
      widgets.forEach(function (widget) {
        if (widget.mbTrustpilotLoaded) return;
        widget.mbTrustpilotLoaded = true;
        window.Trustpilot.loadFromElement(widget, true);
      });
    }

    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === "function") {
      loadWidgets();
      return;
    }

    var script = document.querySelector("script[data-mb-trustpilot]");
    if (script) {
      script.addEventListener("load", loadWidgets, { once: true });
      return;
    }

    script = document.createElement("script");
    script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    script.setAttribute("data-mb-trustpilot", "");
    script.addEventListener("load", loadWidgets, { once: true });
    document.head.appendChild(script);
  }

  /* ---------- Shoppable photography ---------- */

  function initShopLooks(scope) {
    (scope || document).querySelectorAll("[data-shop-looks]").forEach(function (root) {
      if (root.mbBound) return;
      root.mbBound = true;
      var track = root.querySelector("[data-looks-track]");
      var slides = Array.from(root.querySelectorAll("[data-look-slide]"));
      var dots = root.querySelectorAll("[data-look-index]");
      var current = 0;
      var frame = null;
      function closeTags(except) {
        root.querySelectorAll("details[open]").forEach(function (tag) {
          if (tag !== except) tag.open = false;
        });
      }
      function update() {
        frame = null;
        current = Math.round(track.scrollLeft / (track.clientWidth || 1));
        dots.forEach(function (dot, index) {
          if (index === current) dot.setAttribute("aria-current", "true");
          else dot.removeAttribute("aria-current");
        });
        slides.forEach(function (slide, index) {
          slide.inert = index !== current;
        });
      }
      function go(index, instant) {
        if (!slides.length) return;
        closeTags();
        index = (index + slides.length) % slides.length;
        track.scrollTo({
          left: index * track.clientWidth,
          behavior: instant || window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
        });
      }
      root.querySelectorAll("[data-looks-step]").forEach(function (button) {
        button.addEventListener("click", function () {
          go(current + Number(button.dataset.looksStep));
        });
      });
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          go(Number(dot.dataset.lookIndex));
        });
      });
      track.addEventListener(
        "scroll",
        function () {
          closeTags();
          if (!frame) frame = requestAnimationFrame(update);
        },
        { passive: true },
      );
      root.addEventListener(
        "toggle",
        function (event) {
          var tag = event.target;
          if (!tag.matches(".mb-looks__tag") || !tag.open) return;
          closeTags(tag);
          var card = tag.querySelector(".mb-looks__card");
          card.style.transform = "none";
          var bounds = tag.closest("[data-look-slide]").getBoundingClientRect();
          var box = card.getBoundingClientRect();
          var dx = Math.max(bounds.left + 8 - box.left, Math.min(0, bounds.right - 8 - box.right));
          var dy = Math.max(bounds.top + 8 - box.top, Math.min(0, bounds.bottom - 8 - box.bottom));
          card.style.transform = "translate(" + dx + "px," + dy + "px)";
        },
        true,
      );
      root.addEventListener("click", function (event) {
        if (!event.target.closest(".mb-looks__tag")) closeTags();
      });
      root.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          var openTag = root.querySelector("details[open]");
          if (openTag) {
            openTag.open = false;
            openTag.querySelector("summary").focus();
          }
        }
      });
      root.addEventListener("shopify:block:select", function (event) {
        var index = slides.indexOf(event.target.closest("[data-look-slide]"));
        if (index >= 0) go(index, true);
      });
      update();
    });
  }

  /* ---------- Custom jewelry request ---------- */

  function initCommissionForms(scope) {
    (scope || document).querySelectorAll("[data-commission-worker-url]").forEach(function (panel) {
      if (panel.mbCommissionBound) return;
      var endpoint = panel.getAttribute("data-commission-worker-url");
      if (!endpoint) return;
      var form = panel.querySelector(".mb-commission__form");
      var status = panel.querySelector("[data-commission-status]");
      var submit = form && form.querySelector('[type="submit"]');
      var idea = form && form.querySelector('[name="idea"]');
      if (!form || !status || !submit || !idea) return;
      panel.mbCommissionBound = true;

      idea.addEventListener("input", function () {
        idea.setCustomValidity("");
      });

      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        idea.setCustomValidity(
          idea.value.trim().length < 10 ? panel.getAttribute("data-commission-idea-help") || "" : "",
        );
        if (submit.disabled || !form.reportValidity()) return;

        var file = form.querySelector('[type="file"]')?.files?.[0];
        if (file && file.size > 10 * 1024 * 1024) {
          status.textContent = panel.getAttribute("data-commission-file-error") || "";
          status.classList.add("mb-form-status--error");
          status.hidden = false;
          status.focus();
          return;
        }

        var data = new FormData();
        var requestId = form.dataset.commissionRequestId || window.crypto.randomUUID();
        form.dataset.commissionRequestId = requestId;
        data.set("request_id", requestId);
        data.set("full_name", form.querySelector('[name="full_name"]').value.trim());
        data.set("email", form.querySelector('[name="email"]').value.trim());
        data.set("phone", form.querySelector('[name="phone"]').value.trim());
        data.set("jewel_type", form.querySelector('input[type="radio"]:checked')?.value || "");
        data.set("idea", form.querySelector('[name="idea"]').value.trim());
        data.set("marketing_consent", form.querySelector('[name="marketing_consent"]')?.value === "yes" ? "yes" : "no");
        data.set("website", form.querySelector('[name="website"]')?.value || "");
        if (file) data.set("file", file, file.name);

        submit.disabled = true;
        status.hidden = true;
        try {
          var response = await fetch(endpoint, { method: "POST", body: data });
          if (!response.ok) {
            var failure = await response.json().catch(function () {
              return {};
            });
            throw new Error(failure.error || "commission_delivery_failed");
          }
          status.textContent = panel.getAttribute("data-commission-success") || "";
          status.classList.remove("mb-form-status--error");
          status.hidden = false;
          form.reset();
          delete form.dataset.commissionRequestId;
          Analytics.capture("Custom Jewelry Request Submitted", { form_name: "commission" });
        } catch (error) {
          status.textContent =
            error.message === "invalid_fields"
              ? panel.getAttribute("data-commission-validation-error") || ""
              : error.message === "file_too_large"
                ? panel.getAttribute("data-commission-file-error") || ""
                : panel.getAttribute("data-commission-error") || "";
          status.classList.add("mb-form-status--error");
          status.hidden = false;
        } finally {
          submit.disabled = false;
          status.focus();
        }
      });
    });
  }

  /* ---------- Boot ---------- */

  function initAll(scope) {
    initCommissionForms(scope);
    initHeaderScroll(scope);
    initHeaderMenus(scope);
    initSizeGuides(scope);
    initRecipientForms(scope);
    initGalleries(scope);
    initProductForms(scope);
    initShopLooks(scope);
    initTabs(scope);
    initTrustpilot(scope);
    initProductLists(scope);
    initPageAnalytics(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
      openAccordionFromHash();
    });
  } else {
    initAll(document);
    openAccordionFromHash();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  window.MbCartDrawer = CartDrawer;
  window.MbSearchDialog = SearchDialog;
  window.MbAnalytics = Analytics;
})();
